<script>
import lazyLoadComponent from "@router/lazyload-component";
import Layout from "@layouts/main";
import { messageStore, messageDelete } from "@utils/message";
import { messageBoxDelete } from "@utils/message-box";
import { notification } from "@utils/notification";
import goodsMixin from "@/src/mixins/goodsMixin";
import { cloneDeep } from "lodash";
const initData = (type) => {
  return {
    alias: "",
    archivePetSizes: [],
    bufferTime: 0,
    content: "",
    customServicePrices: [],
    description: "", // 商品簡介
    feature: "",
    id: null,
    image: "",
    images: [],
    introtext: "",
    inventory: null,
    no: "",
    notice: "", // 注意事項
    ordering: -1,
    petCategoryId: -1,
    petCategoryTitle: "",
    petSizes: [],
    qty: 0,
    serviceIds: [],
    serviceTime: 0,
    sizeIds: [],
    slogan: null,
    spec: [
      // 初始化spec
      {
        alias: "",
        title: "",
        inputVisible: false,
        values: [
          // {
          //   alias: '',
          //   title: ''
          // }
        ],
      },
    ],
    state: 1,
    storeIds: [],
    tagIds: [],
    title: "",
    type: "goods",
  };
};

export default {
  page: {
    title: "服務項目",
    meta: [{ name: "description", content: "Prepaid List" }],
  },
  components: {
    Layout,
    BaseSteps: () => import("@components/BaseSteps"),
  },
  mixins: [goodsMixin],
  props: {
    /**
     * @description 所有分店
     */
    products: {
      type: Array,
      required: true,
    },
    category: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    /**
     * @description 此次服務項目id
     */
    serviceId: {
      type: [Number, Object],
      default: null, // 如果未提供 serviceId，则默认为 null
    },
  },
  provide() {
    return {
      routerType: this.type,
    };
  },
  data() {
    return {
      createStatus: false,
      cacheData: {},
      cacheOldSpec: [],
      leafOption: [], // 類別陣列
      defaultValue: {}, // 預設資料
      submitData: {}, // submitData 最原始是在async-routes.js進來的
      tryingToStore: false,
      tryingToRemove: false,
      parentCategoryId: null,
      parentCategoryIndex: 0,
      tabList: [
        {
          title: "基本資訊",
          name: "info",
          component: () => lazyLoadComponent(import("./components/TabInfo")),
          pageHeaderTitle: "查看商品-基本資訊",
        },
        {
          title: "規格與價格",
          name: "price",
          component: () => lazyLoadComponent(import("./components/TabPrice")),
          pageHeaderTitle: "查看商品-價格設定",
        },
      ],
      activeTab: "info",
      activeStep: 1,
      tryingNextStep: false,
      selectedPrices: [],
      returnRightTitle: "查看商品-基本資訊",
      validateAddSave: true,
      tabIndex: 0,
      viewSealSpecDialogStatus: false, // 查看封存規格的視窗開啟or關閉
      viewInventoryDialogStatus: false, // 查看庫存數據的視窗開啟or關閉
      validateDiffStatus: false, // 現在是否正在驗證
      cloneSpec: [], // 複製起來的spec，為了不要上一步下一步切換重打
    };
  },
  computed: {
    isEditMode() {
      return this.defaultValue.id;
    },
    isService() {
      return this.$route.params.type !== "addition";
    },
    /**
     * @description 決定要顯示哪種template
     */
    templateRouter() {
      const typeRouter = {
        commodityManage: "tempCommodityManage",
      };
      return typeRouter[this.type];
    },
    /**
     * @description 已經封存的商品
     */
    sealGoods() {
      if (this.createStatus) {
        return [];
      }
      if (!('petSizes' in this.submitData)) {
        return []
      }
      return this.submitData.petSizes.filter((item) => item.state === 2);
    },
    /**
     * @description 查看庫存數據的table資料
     */
    inventoryDialogData() {
      if (this.createStatus) {
        return [];
      }
      let result = {};
      let inventoryTableData = [];
      const { petSizes } = this.submitData;
      if (petSizes && petSizes.length > 0) {
        result = petSizes.reduce((accu, cur) => {
          const { spec_tag: specTag } = cur;
          if (!accu[specTag]) {
            accu[specTag] = {
              inventory: cur.inventory,
              specTagForShow: cur.specTagCutArr,
              specTagOri: specTag,
            };
          } else {
            accu[specTag]["inventory"] = accu[specTag]["inventory"] + cur.inventory;
          }
          return accu;
        }, {});
        inventoryTableData = Object.values(result);
      }
      return inventoryTableData;
    },
  },
  watch: {
    activeTab(nvl, ovl) {
      let { pageHeaderTitle } = this.tabList.find((item) => item.name === nvl);
      this.returnRightTitle = pageHeaderTitle;
      this.tabIndex = this.tabList.findIndex((item) => item.name === nvl);
    },
  },
  mounted() {
    if (this.isService) {
      if (this.isEditMode) {
        this.$route.meta.title = "編輯商品";
      } else {
        this.$route.meta.title = "新增商品";
      }
    }
  },
  async created() {
    this.createStatus = true;
    await this.fetchDefaultValue();
    await this.fetchSelectLeaf();
    this.createStatus = false;
  },
  methods: {
    /**
     * @description 取得defaultValue
     */
    async fetchDefaultValue() {
      if (this.serviceId) {
        this.defaultValue = await this.$store.dispatch(
          "product/fetchSingleServiceData",
          this.serviceId
        );
        const submitData = Object.assign({}, initData(), this.defaultValue, {
          description:
            this.defaultValue.description &&
            this.defaultValue.description.replace(/<br\s\/>/g, ""),
          content:
            this.defaultValue.content &&
            this.defaultValue.content.replace(/<br\s\/>/g, ""),
          notice:
            this.defaultValue.notice && this.defaultValue.notice.replace(/<br\s\/>/g, ""),
        });
        this.submitData = submitData;
        this.cacheOldSpec = cloneDeep(this.submitData.spec);
      } else {
        this.defaultValue = initData();
        this.submitData = cloneDeep(this.defaultValue);
        this.cacheOldSpec = cloneDeep(this.submitData.spec);
      }
    },
    /**
     * @description 查看庫存數據的func
     */
    viewInventoryDialog() {
      this.viewInventoryDialogStatus = true;
    },
    /**
     * @description 查看封存規格的func
     */
    viewSealSpec() {
      this.viewSealSpecDialogStatus = true;
    },
    /**
     * @description click Tab
     */
    handleClick(tab) { },
    /**
     * @description 勾選到的資料
     * @param {Array} selectedData
     */
    updateSelectedPrices(selectedData) {
      this.selectedPrices = [];
      for (let i = 0, len = selectedData.length; i < len; i++) {
        this.selectedPrices.push(selectedData[i]);
      }
    },
    /**
     * @description 這個頁面打api後，設定資料
     */
    setSubmitData() {
      try {
        const submitData = Object.assign({}, initData(), this.cacheData, {
          description:
            this.cacheData.description &&
            this.cacheData.description.replace(/<br\s\/>/g, ""),
          content:
            this.cacheData.content && this.cacheData.content.replace(/<br\s\/>/g, ""),
          notice: this.cacheData.notice && this.cacheData.notice.replace(/<br\s\/>/g, ""),
        });
        this.submitData = submitData;
      } catch (error) {
        console.error(error.message);
      }
    },
    /**
     * @description 儲存完之後，打這支重新撈取資料
     */
    async tryToFetchSingle() {
      this.cacheData = await this.$store.dispatch(
        "product/fetchSingleServiceData",
        this.submitData.id
      );
      this.setSubmitData();
    },
    /**
     * @description 點擊往下一步
     */
    async onClickNextStep() {
      try {
        await this.validateTabInfoSubmitData();
        if (this.validateCloneSpecAndSubmitSpec()) {
          await this.fetchDiffAndChangePetSize();
        }
        this.tryingNextStep = true; // 試著往下走
        this.activeStep++; // 往下走一個tab(for 新增)
      } catch (error) {
        console.error(error.message);
        this.$message.error(error.message);
      }
    },
    /**
     * @description 
     */
    validateCloneSpecAndSubmitSpec() {
      // 如果沒有clone過規格，直接讓他往下走
      if (this.cloneSpec.length === 0) {
        return true
      } else {
        return this.areArraysEqual(this.cloneSpec, this.submitData.spec)
      }
    },
    areObjectsEqual(obj1, obj2) {
      return obj1.alias === obj2.alias && obj1.title === obj2.title;
    },
    // 检查两个对象的"values"是否相同
    areValuesEqual(values1, values2) {
      if (values1.length !== values2.length) {
        return false;
      }
      for (let i = 0; i < values1.length; i++) {
        if (!this.areObjectsEqual(values1[i], values2[i])) {
          return false;
        }
      }
      return true;
    },

    // 判断两个数组的对象是否相同，包括"title"、"alias"和"values"
    areArraysEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) {
        return true;
      }
      for (let i = 0; i < arr1.length; i++) {
        if (!this.areObjectsEqual(arr1[i], arr2[i]) || !this.areValuesEqual(arr1[i].values, arr2[i].values)) {
          return true;
        }
      }
      return false;
    },
    /**
     * @description 新增/修改時，將tabInfo的submitData更新一直傳上來
     */
    submitDataInTabInfoUpdate(nvl) {
      this.submitData = nvl;
    },
    /**
     * @description 找到規格變化
     */
    async fetchSpecDiff() {
      try {
        let result = {};

        if (!this.submitData.id) {
          // 新增模式，看規格變化
          result = await this.$store.dispatch("product/postToGetSpecDiff", {
            oldSpecs: [],
            newSpecs: this.submitData.spec,
          });
          if (!this.validateDiffStatus) {
            this.submitData.petSizes = [];
          }
        } else {
          // 修改模式看規格變化
          result = await this.$store.dispatch("product/postToGetSpecDiff", {
            oldSpecs: this.cacheOldSpec,
            newSpecs: this.submitData.spec,
          });
        }
        if (!this.validateDiffStatus) {
          this.cacheOldSpec = cloneDeep(this.submitData.spec);
        }
        return result;
      } catch (error) {
        console.error(error.message);
      }
    },
    goBack() {
      this.cloneSpec = cloneDeep(this.submitData.spec)
      this.activeStep--;
    },
    /**
     * @description 取得category id
     */
    getPetCategoryId() {
      try {
        const petCategory = this.leafOption.find(
          (item) => item.categoryTitle === this.submitData.petCategoryTitle
        );
        if (petCategory) {
          return petCategory.id;
        } else {
          throw new Error("error");
        }
      } catch (error) {
        console.error(error.message);
      }
    },
    /**
     * @description 取得category id
     */
    getPetCategoryId() {
      try {
        console.log("🚀 ~ file: ServiceItemDetail.vue:384 ~ getPetCategoryId ~ this.leafOption:", this.leafOption)
        const petCategory = this.leafOption.find((item) => item.categoryTitle === this.submitData.petCategoryTitle);
        console.log("🚀 ~ file: ServiceItemDetail.vue:383 ~ getPetCategoryId ~ petCategory:", petCategory)
        if (petCategory) {
          return petCategory.id
        } else {
          throw new Error('error')
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 組成新增的資料
     */
    composeSubmitDataBeforeSaveAdd() {
      try {
        this.$set(this.submitData, "petCategoryId", this.getPetCategoryId());
        this.$set(this.submitData, "id", null);
        this.$set(this.submitData, "sizes", this.submitData.petSizes);
      } catch (error) {
        console.error(error.message);
      }
    },
    /**
     * @description 組成修改儲存的資料(for service or addtion)
     */
    composeSubmitDataBeforeSaveEdit() {
      try {
        this.$set(this.submitData, "petCategoryId", this.getPetCategoryId());
        this.submitData.petSizes.forEach((item) => {
          const numberTypeInventory = Number(item.inventory);
          if (isNaN(numberTypeInventory)) {
            throw new Error("請輸入整數");
          } else {
            this.$set(item, "inventory", numberTypeInventory);
          }
        });
        this.$set(this.submitData, "sizes", this.submitData.petSizes);
      } catch (error) {
        console.error(error.message);
        this.$message.error(error.message);
      }
    },
    /**
     * @description 修正一些為null的值
     */
    fixNullValueInSubmitData() {
      this.$set(
        this.submitData,
        "notice",
        this.submitData.notice ? this.submitData.notice : ""
      );
      this.$set(
        this.submitData,
        "introtext",
        this.submitData.introtext ? this.submitData.introtext : ""
      );
      this.$set(
        this.submitData,
        "content",
        this.submitData.content ? this.submitData.content : ""
      );
    },
    /**
     * @description 驗證要提交出去的submitData - for TabInfo
     */
    async validateTabInfoSubmitData() {
      return new Promise((resolve, reject) => {
        if (this.submitData.spec.length === 0) {
          reject(new Error("請填寫規格"));
        }
        if (this.submitData.title.length === 0) {
          reject(new Error("請填寫名稱"));
        }
        if (this.submitData.petCategoryTitle.length === 0) {
          reject(new Error("請填寫類別"));
        }
        if (this.submitData.no.length === 0) {
          reject(new Error("請填寫貨號"));
        }
        if (this.submitData.description.length === 0) {
          reject(new Error("請填寫商品簡介"));
        }
        if (this.submitData.spec.length > 0) {
          for (let e of this.submitData.spec) {
            if (e.values.length === 0 || e.title.length === 0) {
              throw new Error("請填寫正確規格");
            }
          }
        }
        if (this.submitData.spec.length === 0) {
          reject(new Error("請填寫正確規格"));
        }
        if (this.submitData.no.length > 0 && !(/^#[0-9a-zA-Z]+$/.test(this.submitData.no))) {
          reject(new Error("請填寫正確貨號，並且首字需要「#」字號"));
        }
        resolve();
      });
    },
    /**
     * @description 驗證要提交出去的submitData - for TabPrice
     */
    async validateTabPriceSubmitData() {
      for (let e of this.submitData.petSizes) {
        let inputBasePrice = +e["prices"][0].basePrice;
        let inputPrice = +e["prices"][0].price
        let inputCostPrice = +e["prices"][0].costPrice;
        if (e["prices"][0].basePrice === '' || e["prices"][0].price === '') {
          throw new Error("原價或是售價不得為空");
        }
        if (isNaN(inputBasePrice) || inputBasePrice < 0) {
          console.log("🚀 ~ file: ServiceItemDetail.vue:464 ~ validateTabPriceSubmitData ~ inputBasePrice < 0:", inputBasePrice < 0)
          console.log("🚀 ~ file: ServiceItemDetail.vue:464 ~ validateTabPriceSubmitData ~ !isNaN(inputBasePrice):", !isNaN(inputBasePrice))
          throw new Error("請填寫正確原價");
        }
        if (isNaN(inputBasePrice) || inputCostPrice < 0) {
          throw new Error("請填寫正確成本價");
        }
        if (isNaN(inputPrice) || inputPrice < 0) {
          throw new Error("請填寫正確售價");
        }
        if ("noCutArr" in e && e.noCutArr[1].length === 0) {
          throw new Error("請填寫正確貨號");
        }
        if ("noCutArr" in e && e.noCutArr[1].length > 0 && !(/^[0-9a-zA-Z]+$/.test(e.noCutArr[1]))) {
          throw new Error("貨號請填入英文或數字");
        }


      }
    },
    /**
     * @description 驗證diff 資訊
     */
    async validateDiff() {
      const { items } = await this.fetchSpecDiff();
      if (!this.isEditMode) {
        return;
      }
      if (
        this.isEditMode &&
        items.adds.length === 0 &&
        items.deletes.length === 0 &&
        items.renames.length === 0
      ) {
        await this.fetchDiffAndChangePetSize();
        return;
      }
      if (this.isEditMode && items.adds.length > 0) {
        throw new Error("請到規格與價格設定詳細貨號");
      }
      if (this.isEditMode && items.adds.length === 0) {
        this.replacePetSizesSpecTag(items); // 替換掉文字
        this.setPetSizesSpecTagState2(items); // 設定封存的數據
        this.setPetSizesNoArray(); // 設定貨號 // 已經換掉過一次，這邊先不用做
        this.setPetSizesSpecTag(); // 設定specTag要顯示的資料
      }
    },
    /**
     * @description 將新增的資料變回原狀
     */
    setPetSizesAddId() {
      this.submitData.petSizes.forEach(item => {
        if (typeof item.id === 'string' && item.id.includes('fake') && item.state === 1) {
          this.$set(item, 'id', null)
        }
      })
    },
    /**
     * @description 儲存此商品
     */
    async tryToStore(type) {
      try {
        this.validateDiffStatus = true;
        await this.validateDiff();
        await this.validateTabInfoSubmitData();
        await this.validateTabPriceSubmitData();
        this.setPetSizesAddId() // 驗證完之後，把資料復原，記得一定要驗證完之後才可以
        const todoType = {
          commodityManage: {
            apiUrl: "product/storeServicePriceGroup",
            editModeCompose: this.composeSubmitDataBeforeSaveEdit,
            addModeCompose: this.composeSubmitDataBeforeSaveAdd,
          },
        };
        if (this.isEditMode) {
          todoType[this.type]["editModeCompose"]();
        } else {
          todoType[this.type]["addModeCompose"]();
        }
        console.log(this.submitData);
        console.log("validate Finish");
        // this.submitData.petSizes.forEach(item => {
        //   console.log(item.state)
        //   console.log(item.spec_tag)
        //   console.log(item.params.images)
        // })
        // return
        this.tryingToStore = true;
        await this.$store.dispatch(`${todoType[this.type]["apiUrl"]}`, this.submitData);
        if (this.isEditMode) {
          messageStore("edit");
          this.activeTab = "info";
          // await this.fetchDefaultValue();
          this.backToList();
        } else {
          messageStore("add");
          this.backToList();
        }
        // const todoType = {
        //   commodityManage: {
        //     apiUrl: 'product/storeServicePriceGroup',
        //     editModeCompose: this.composeSubmitDataBeforeSaveEdit,
        //     addModeCompose: this.composeSubmitDataBeforeSaveAdd,
        //   },
        // };
        // this.tryingToStore = true;
        // if (this.isEditMode) {
        //   await this.fetchDiffAndChangePetSize()
        //   todoType[this.type]['editModeCompose']()
        //   console.log('1')
        // } else {
        //   todoType[this.type]['addModeCompose']()
        //   console.log('2')
        // }
        // await this.$store.dispatch(`${todoType[this.type]['apiUrl']}`, this.submitData);
        // if (this.isEditMode) {
        //   messageStore('edit');
        //   this.activeTab = 'info'
        //   await this.fetchDefaultValue()
        // } else {
        //   messageStore('add');
        //   this.backToList();
        // }
      } catch (error) {
        this.$message.error(error.message);
      } finally {
        this.validateDiffStatus = false;
        this.tryingToStore = false;
      }
    },
    findCategory() {
      const id = this.defaultValue.petSizes[0].sizeId;
      if (this.category.length > 0) {
        this.category.forEach((item) => {
          const ids = item.children.map((child) => child.id);
          if (ids.includes(id)) {
            this.parentCategoryId = item.id;
          }
        });
      }
    },
    getService() { },
    /**
     * @description 商品的返回（轉移成商品ok）
     */
    backToList() {
      this.$router.push({
        name: "goods",
        params: {
          type: this.type,
        },
      });
    },
    /**
     * @description 換掉petSizes no
     */
    setPetSizesNoArray() {
      try {
        const { no: oriNo } = this.defaultValue;
        const { petSizes, no: newNo } = this.submitData;
        petSizes.forEach((item) => {
          let knownString = `${oriNo}-`;
          let inputString = item.no; // 使用者key in的貨號
          let parts = [];
          // 貨號沒有修改，TabInfo & TabPrice 相同就會走這邊
          if (
            oriNo === newNo &&
            inputString.startsWith(knownString) &&
            inputString.length > 0
          ) {
            parts.push(newNo); // 将已知字符串放在数组的第一个元素
            parts.push(inputString.substring(knownString.length)); // 将剩余部分放在数组的第二个元素
            this.$set(item, "noCutArr", parts);
          }
          // 貨號有修改，TabInfo & TabPrice 不同就會走這邊
          if (
            oriNo !== newNo &&
            !inputString.startsWith(knownString) &&
            inputString.length > 0
          ) {
            parts.push(newNo); // 将已知字符串放在数组的第一个元素
            parts.push(inputString.substring(newNo.length + 1)); // 将剩余部分放在数组的第二个元素 +1 代表再往後取一格
            this.$set(item, "noCutArr", parts);
          }
          // 如果沒有貨號，代表新增，所以走這
          if (!inputString.startsWith(knownString) && inputString.length === 0) {
            this.$set(item, "noCutArr", [newNo, ""]);
            this.$set(item, "no", newNo);
          }
        });
      } catch (error) {
        console.error(error.message);
      }
    },
    /**
     * @description 取代掉原始字串
     */
    replacePetSizesSpecTag(diffResult) {
      try {
        const { renames } = diffResult;
        if (renames.length === 0) {
          // === 0 代表沒有改名
          return;
        }
        const { replaceFrom, replaceTo } = renames[0];
        const { petSizes } = this.submitData;
        petSizes.forEach((item) => {
          let inputString = item.spec_tag;
          // 使用字符串替换方法将'容量spec5oWaw'替换成'容量CCspec5oWaw'
          let modifiedString = inputString.replace(replaceFrom, replaceTo);
          this.$set(item, "spec_tag", modifiedString);
        });
      } catch (error) {
        console.error(error.message);
      }
    },
    /**
     * @description 設定增加的數據
     */
    setPetSizesSpecTagState1(diffResult) {
      try {
        const { adds } = diffResult;
        if (adds.length === 0) {
          return;
        }
        const { petSizes } = this.submitData;
        let fakeIndex = 0
        this.products.forEach((store) => {
          adds.forEach((item) => {
            petSizes.push({
              alias: "",
              bufferTime: 0,
              id: `fake-${fakeIndex++}`,
              inventory: 0,
              no: "",
              ordering: -1,
              prices: [
                {
                  id: null,
                  spaceId: null,
                  basePrice: 0,
                  price: 0,
                  isFlexible: 0,
                  params: [],
                  costPrice: null,
                },
              ],
              productId: store.id,
              serviceTime: 0,
              sizeId: 0,
              sizeTitle: "",
              spec: this.submitData.spec,
              spec_tag: item,
              state: 1,
              storeTitle: store.name,
              params: {
                images: [
                  {
                    path: "",
                    default: 1,
                  },
                ],
              },
            });
          });
        });
      } catch (error) {
        console.error(error.message);
      }
    },
    /**
     * @description 設定封存的數據
     */
    setPetSizesSpecTagState2(diffResult) {
      try {
        const { deletes } = diffResult;
        if (deletes.length === 0) {
          return;
        }
        const { petSizes } = this.submitData;
        petSizes.forEach((item) => {
          // 去找封存的字串是否跟deletes一樣，如果一樣就將state改成2
          const findSpecTagIndex = deletes.findIndex(
            (deleteItem) => deleteItem === item.spec_tag
          );
          if (findSpecTagIndex > -1) {
            item.state = 2;
          }
        });
      } catch (error) {
        console.error(error.message);
      }
    },
    /**
     * @description 從一串長的文字中，切割出所需要的形式
     */
    specTagSplit(specTagStr) {
      try {
        // 首先使用逗号分割字符串
        let parts = specTagStr.split(",");
        // 创建一个空数组来存储容量信息
        let oriCutArr = [];
        // 循环处理每个部分
        for (let i = 0; i < parts.length; i++) {
          let part = parts[i];
          let splitPart = part.split(":"); // 使用冒号分割部分并将结果存储为一个数组
          if (splitPart.length === 2) {
            let extractedText = []; // 如果成功分割成两个元素，将其添加到容量信息数组中
            for (let i = 0; i < splitPart.length; i++) {
              // 循环处理每个元素
              let element = splitPart[i];
              let match = element.match(/(.*)spec/); // 使用正则表达式匹配 "spec" 之前的文字
              if (match) {
                extractedText.push(match[1]); // 如果匹配成功，将提取的文字添加到新数组中
              }
            }
            oriCutArr.push(extractedText);
          }
        }
        return oriCutArr;
      } catch (error) {
        console.error(error.message);
      }
    },
    /**
     * @description 切割spec_tag給「規格與價格」
     */
    setPetSizesSpecTag() {
      try {
        const { petSizes } = this.submitData;
        petSizes.forEach((item) => {
          const { spec_tag: specTag } = item;
          this.$set(item, "specTagCutArr", this.specTagSplit(specTag));
        });
      } catch (error) {
        console.error(error.message);
      }
    },
    /**
     * @description 獲取diff && 改變submitData的petSizes
     */
    async fetchDiffAndChangePetSize() {
      const { items } = await this.fetchSpecDiff();
      this.replacePetSizesSpecTag(items); // 替換掉文字
      this.setPetSizesSpecTagState2(items); // 設定封存的數據
      this.setPetSizesSpecTagState1(items); // 設定增加的數據
      this.setPetSizesNoArray(); // 設定貨號 // 已經換掉過一次，這邊先不用做
      this.setPetSizesSpecTag(); // 設定specTag要顯示的資料
    },
    /**
     * @description tab 切換之前，要做哪些事
     */
    async beforeTabSwitch(activeName, oldActiveName) {
      try {
        if (this.activeTab === "info") {
          // 修改模式的info驗證
          await this.validateTabInfoSubmitData();
        }
        if (this.activeTab === "price") {
          // 修改模式的price驗證
          await this.validateTabPriceSubmitData();
        }
        await this.fetchDiffAndChangePetSize();
        return new Promise((resolve, reject) => {
          resolve();
        });
      } catch (error) {
        console.error(error.message);
        this.$message.error(error.message);
        return new Promise((resolve, reject) => {
          reject(new Error("error"));
        });
      }

    },
    /**
     * @secription 上架下架商品
     * @param {String} type
     */
    async onMarketOrSoldOut(type) {
      try {
        await this.$store.dispatch("product/onMarketorSoldOut", {
          state: type === "onMarket" ? 1 : 0,
          ids: this.selectedPrices.map((item) => item.id),
          service_id: this.defaultValue.id,
        });
        this.$message({
          message: type === "onMarket" ? "上架成功" : "下架成功",
          type: "success",
        });
        this.activeTab = "info";
        await this.tryToFetchSingle();
        this.setPetSizesNoArray(); // 設定貨號
        this.setPetSizesSpecTag(); // 設定specTag要顯示的資料
      } catch (error) {
        console.error(error.message);
        this.$message.error(error.message);
      }
    },
    async deleteSelected() {
      try {
        this.tryingToRemove = true;
        if (this.defaultValue.id) {
          await messageBoxDelete("此服務項目");
          await this.$store.dispatch("product/serviceRemove", {
            ids: [this.defaultValue.id],
          });
          messageDelete();
          this.backToList();
        }
      } catch (error) {
        console.error(error.message);
      } finally {
        this.tryingToRemove = false;
      }
    },
    /**
     * @description 更新人員變價
     */
    updateChangePrice(nvl) {
      try {
        const customServicePrices = nvl.reduce((accu, cur) => {
          const selectPrice = cur.sizePrices.reduce((innerAccu, innerCur) => {
            if (innerCur.selectedStatus) {
              innerAccu.push({
                price: innerCur.changePriceNumber,
                servicePriceId: innerCur.id,
              });
            }
            return innerAccu;
          }, []);
          accu.push({
            scheduleItemId: cur.id,
            servicePrices: selectPrice,
          });
          return accu;
        }, []);
        this.$set(this.submitData, "customServicePrices", customServicePrices);
      } catch (error) {
        console.error(error.message);
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div v-if="Object.keys(defaultValue).length > 0" style="margin-bottom: 60px">
      <!-- 修改模式 -->
      <template v-if="isEditMode">
        <el-tabs v-model="activeTab" stretch :before-leave="beforeTabSwitch" type="border-card" class="isStyleBase"
          @tab-click="handleClick">
          <el-tab-pane v-for="(tab, index) in tabList" :key="index" :label="tab.title" :name="tab.name">
          </el-tab-pane>
        </el-tabs>
        <div :class="$style.upperBtn">
          <div>
            <el-page-header :content="returnRightTitle" @back="backToList"></el-page-header>
          </div>
          <div v-if="isEditMode && activeTab === 'price'">
            <el-button class="is-round" :disabled="sealGoods.length === 0" :class="$style['upperBtn__marketWidth']"
              @click="viewSealSpec">查看封存規格</el-button>
            <el-button class="is-round" :disabled="false" :class="$style['upperBtn__marketWidth']"
              @click="viewInventoryDialog">查看庫存數據</el-button>
            <el-button class="is-round" :disabled="selectedPrices.length === 0" :class="$style['upperBtn__marketWidth']"
              @click="onMarketOrSoldOut('onMarket')">上架項目</el-button>
            <el-button class="is-round" :disabled="selectedPrices.length === 0" :class="$style['upperBtn__marketWidth']"
              @click="onMarketOrSoldOut('soldOut')">
              下架項目</el-button>
          </div>
        </div>
        <div v-for="(tab, index) in tabList" :key="`goods${index}`" :class="$style.componentStyle">
          <component :is="tab.component" v-show="index === tabIndex" :ref="tab.name" :default-value.sync="submitData"
            :category-index.sync="parentCategoryIndex" :service-id="serviceId" :category-id.sync="parentCategoryId"
            :products="products" :category="category" :template-type="templateRouter" @store="tryToStore"
            @update="tryToFetchSingle" @updateSelectedPrices="updateSelectedPrices" @updateChangePrice="updateChangePrice"
            @submitDataInTabInfoUpdate="submitDataInTabInfoUpdate" />
        </div>
        <div :class="$style.footer">
          <el-button class="is-round" @click="backToList">取消</el-button>
          <el-button class="is-round" type="primary" data-tour-step="5" data-tour-text="最後別忘記按下「完成」，完成此方案新增了唷！"
            :loading="tryingToStore" :disabled="tryingToStore" @click="tryToStore">
            <BaseIcon v-if="!tryingToStore" name="check" />
            <span>{{ isEditMode ? "儲存" : "建立" }}</span>
          </el-button>
        </div>
      </template>
      <!-- 新增模式 -->
      <template v-else>
        <BaseSteps :active="activeStep" :list="tabList" />
        <div :class="$style['thisPageCardStyle']">
          <el-card :class="[$style['card-wrapper'], $style['card-inner']]">
            <keep-alive>
              <component :is="tabList[activeStep - 1].component" :ref="tabList[activeStep - 1].name"
                :default-value.sync="submitData" :service-id="serviceId" :category-index.sync="parentCategoryIndex"
                :category-id.sync="parentCategoryId" :template-type="templateRouter" :products="products"
                :category="category" @store="tryToStore" @submitDataInTabInfoUpdate="submitDataInTabInfoUpdate" />
            </keep-alive>
            <div :class="$style.footer">
              <el-button class="is-round" @click="backToList">取消</el-button>
              <el-button v-if="activeStep !== 1" class="is-round" @click="goBack">上一步</el-button>
              <el-button v-if="activeStep !== 2" class="is-round" data-tour-text="若欄位皆已填寫完成，點擊「下一步」儲存此步驟填寫的資料，前往下一步"
                type="primary" @click="onClickNextStep(activeStep)">
                {{ `下一步` }}
              </el-button>
              <el-button v-if="activeStep === 2" class="is-round" type="primary" data-tour-step="5"
                data-tour-text="最後別忘記按下「完成」，完成此方案新增了唷！" :loading="tryingToStore" :disabled="tryingToStore"
                @click="tryToStore">
                <BaseIcon v-if="!tryingToStore" name="check" />
                <span>{{ isEditMode ? "儲存" : "建立" }}</span>
              </el-button>
            </div>
          </el-card>
        </div>
      </template>
      <el-dialog title="封存規格" :visible.sync="viewSealSpecDialogStatus" top="0" width="680px" append-to-body>
        查看規格為舊有規格，現已封存
        <el-table v-if="sealGoods.length > 0" ref="multipleTable" :data="sealGoods"
          :class="[$style['table'], $style['specClass']]" style="padding-top: 15px" height="600">
          <el-table-column v-slot="{ row }" label="規格" prop="type" min-width="200">
            <div>
              {{ row.storeTitle }}
            </div>
            <div v-for="(item, index) in row.specTagCutArr" :key="`spec-${index}`">
              <div>
                <span>{{ item[0] }}：</span>
                <span>{{ item[1] }}</span>
              </div>
            </div>
          </el-table-column>
          <el-table-column v-slot="{ row }" label="庫存數量" prop="type" min-width="100">
            <span>{{ row.inventory }}</span>
          </el-table-column>
        </el-table>
      </el-dialog>
      <el-dialog title="查看庫存數據" :visible.sync="viewInventoryDialogStatus" top="0" width="680px" append-to-body>
        庫存數據為「清潔呼吸潔顏霜」商品的各式規格而不同分店總和，以下數據提供參考
        <el-table v-if="Object.keys(inventoryDialogData).length > 0" :data="inventoryDialogData"
          :class="[$style['table'], $style['specClass']]" style="padding-top: 15px" height="600">
          <el-table-column v-slot="{ row }" label="規格" prop="type" min-width="100">
            <div v-for="(item, index) in row.specTagForShow" :key="`spec-${index}`">
              <div>
                <span>{{ item[0] }}：</span>
                <span>{{ item[1] }}</span>
              </div>
            </div>
          </el-table-column>
          <el-table-column v-slot="{ row }" label="庫存數量" prop="type" min-width="100">
            <span>{{ row.inventory }}</span>
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import "@src/design/layout_detail_steps.scss";

.thisPageCardStyle {
  :global {
    .el-card.is-always-shadow {
      box-shadow: none;
    }

    .el-card__body {
      padding: 0 20px 20px;
    }
  }
}

.card-inner {}

:global {
  .el-page-header {
    align-items: center;
    font-size: 22px;
  }

  .el-page-header__left {
    border: 1px solid $color-border-for-bg-white;
    border-radius: $border-radius;
    padding: 12px 24px;
    background-color: white;
  }
}

.upperBtn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px;

  &__marketWidth {
    width: 150px;
  }
}

.componentStyle {
  margin: 20px;
}

.specClass {
  :global {
    .el-table__header-wrapper {
      margin-bottom: 10px;
    }

    tr.el-table__row {
      background-color: #f6f6f6;
    }

    .el-table__body {
      padding-bottom: 20px;
    }

    .cell {
      padding-left: 25px;
    }
  }
}
</style>
